import React from 'react';
import { useHistory } from 'react-router-dom';
import './ComponenteWeb.css'; // Asegúrate de crear este archivo de estilos
import { useTranslation } from 'react-i18next';
import ChatBot from '../Chatbot/ChatBot';
import LandingPageResult from './LandingPageResult';

const ComponenteWeb2: React.FC = () => {
    const { t } = useTranslation();

  return (
    <div className="componente-superior-Web2">
    <div className="columna-izquierda-web2">
        {/* Aquí podrías incluir el formulario de selección de imágenes o cualquier otro contenido */}
        <ChatBot />
    </div>
    <div className='columna-central-web2'>
        {/* Asegúrate de que cada prop sea pasada correctamente y que todos los corchetes estén cerrados */}
        <LandingPageResult />
    </div>
    {/* Asegúrate de que mainImage y thumbnails sean pasados correctamente a ImageResult */}
</div>
  );
};

export default ComponenteWeb2;
